import { render, staticRenderFns } from "./CVideoTab.vue?vue&type=template&id=3e88cb22&scoped=true&"
import script from "./CVideoTab.vue?vue&type=script&lang=js&"
export * from "./CVideoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88cb22",
  null
  
)

export default component.exports